import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { SessionProvider } from "./session/useSession";
import { ToastProvider } from "./shell/Toasts";
import { ViewStateProvider } from "./shell/viewState";
import { isGalleryHash } from "./mc/gallery/route";
import "./styles/app.css";
import "./styles/print.css";
import "./styles/brand.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 } },
});

const root = document.getElementById("root")!;

// The Mission Control V2 design-system gallery exists only in a capture build (VITE_MC_CAPTURE=true); without the
// flag this branch and its chunk are dropped from the bundle.
if (import.meta.env.VITE_MC_CAPTURE === "true" && isGalleryHash(location.hash)) {
  void import("./mc/gallery/boot").then((gallery) => gallery.bootGallery(root));
} else {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <ViewStateProvider>
            <SessionProvider>
              <App />
            </SessionProvider>
          </ViewStateProvider>
        </ToastProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}
